// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KRKrBrX2aXrH0ZOhbW5N {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 300px;
    padding: 0 20px 32px 20px;
}

.ByspLBKO3MRAKG5SMlnA {
    display: flex;
    justify-content: space-between;
    float: right;
}

.tNrKAXXJGephGipLD5IQ {
    align-self: center;
}

.ddzFtyK2q67VtQelvN23 {
    font-size: 16px;
    line-height: 1.8;
}

.cNo1SGIeXDw7IZ3IbCam {
    color: hsl(0, 0%, 50%);
    font-size: 12px;
}

.LqemsiKbp1luBSGX4ZLU {
    display: flex;
    flex: 1;
}

.ri0T5ENMDezDAJr_IhiL {
    margin: 36px auto;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/dashboard/components/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".page {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 300px;\n    padding: 0 20px 32px 20px;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    float: right;\n}\n\n.select {\n    align-self: center;\n}\n\n.heading {\n    font-size: 16px;\n    line-height: 1.8;\n}\n\n.subheading {\n    color: hsl(0, 0%, 50%);\n    font-size: 12px;\n}\n\n.content {\n    display: flex;\n    flex: 1;\n}\n\n.loading {\n    margin: 36px auto;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `KRKrBrX2aXrH0ZOhbW5N`,
	"header": `ByspLBKO3MRAKG5SMlnA`,
	"select": `tNrKAXXJGephGipLD5IQ`,
	"heading": `ddzFtyK2q67VtQelvN23`,
	"subheading": `cNo1SGIeXDw7IZ3IbCam`,
	"content": `LqemsiKbp1luBSGX4ZLU`,
	"loading": `ri0T5ENMDezDAJr_IhiL`
};
export default ___CSS_LOADER_EXPORT___;
